import { StockListPage } from './../../../stock/stock-list/stock-list';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DeliberyNoteCreateSelectProviderPage } from '../../../delibery_note/delibery-note-create/delibery-note-create-select-provider/delibery-note-create-select-provider';
import { IngredientViewPage } from '../../../ingredients/ingredient-view/ingredient-view/ingredient-view';
import { ProductViewPage } from '../../../products/product-view/product-view/product-view';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ProviderOrderCartPage } from '../../../providers/orders/provider-order-cart/provider-order-cart';
import { ProvidersServices } from '../../../providers/services';

/**
 * Generated class for the HomeDashboardStockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-stock-list',
  templateUrl: 'home-dashboard-stock-list.html',
})
export class HomeDashboardStockListPage {

  less_stock: any = [];
  more_stock: any = [];
  stock_value_store: any = 0;
  total_deliberynote_month: any = 0;
  data_less_stock: boolean = false;
  data_more_stock: boolean = false;
  get_analytics: boolean = false
  counter_elements: number = 0

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public providersServices: ProvidersServices) {
    this.loadAnaltycs();
  }

  async loadAnaltycs() {
    if (this.globals.public_key == '') {
      await this.globals.delay(3000);
    }
    this.lessStock();
    this.moreStock();
    this.stockValueStore();
    this.totalDeliberynoteMonth();
    this.getElements();
  }

  async lessStock() {

    await this.http.post(this.globals.analytics_path + 'less-stock/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.less_stock = data;

      this.data_less_stock = true;
      this.get_analytics = true;
    },
      err => {
      }
    );
  }
  async moreStock() {

    await this.http.post(this.globals.analytics_path + 'more-stock/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.more_stock = data;


      this.data_more_stock = true;
      this.get_analytics = true;

    },
      err => {
      }
    );
  }
  async stockValueStore() {
    //Funcion que pide el valor total del stock
    this.get_analytics = false;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    this.http.post(this.globals.analytics_path + 'bistock/stock_value_store', params, {})
      .subscribe(res => {
        this.stock_value_store = res;
        this.get_analytics = true;
      });
  }

  async getElements() {

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    await this.http.post(this.globals.analytics_path + 'paginate/all_ingredients_products', params, {})
      .subscribe(async res => {

        this.counter_elements = res['list'].length;
        this.get_analytics = true;
      })

  }

  async totalDeliberynoteMonth() {

    await this.http.post(this.globals.analytics_path + 'total-deliberynote-month/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.total_deliberynote_month = data;
    },
      err => {
      }
    );
  }
  createDeliberyNote() {
    if (this.globals.checkLimitsByLicense('stock', 'delivery_notes')) {
      this.navCtrl.push(DeliberyNoteCreateSelectProviderPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }
  openItem(item) {
    if (item.type == 'ingredient') {
      this.navCtrl.push(IngredientViewPage, {
        ingredient_uid: item.uid,
        ingredient_name: item.name
      });
    } else {
      this.navCtrl.push(ProductViewPage, {
        product_uid: item.uid,
        product_name: item.name,
        product_sub_recipe: item.sub_recipe
      });
    }
  }
  openStock() {
    this.navCtrl.push(StockListPage);
    this.globals.side_menu_active = 'stock';
  }

  openLanding() {
    if (this.globals.so_mobile) {
      window.location.assign('https://landing.mycheftool.com/es/stock');
    } else {
      window.open('https://landing.mycheftool.com/es/stock', '_blank');
    }
  }

  openCart() {
    if (this.globals.checkLimitsByLicense('stock', 'pedidos')) {
      this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
      this.navCtrl.push(ProviderOrderCartPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
    this.globals.open_side_menu = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-stock-list/home-dashboard-stock-list.ts